import { AgGridButtons } from "@/controls/buttons/AgGridButtons";
import { ScrapData } from "@/pages/heat-report/models/HeatReportModels";
import { ColDef, ColGroupDef, ICellRendererParams } from "ag-grid-community";

export interface IScrapRow {
	id: string; // 'scrap1' or 'scrap2'
	length: number | null;
	pieces: number | null;
	codeId: string | null;
}

interface UseScrapTableDataProps {
	scrapData: ScrapData;
}

const formatLength = (lengthInInches: number | null | undefined): string => {
	if (lengthInInches === null || lengthInInches === undefined)
		lengthInInches = 0;
	const feet = Math.floor(lengthInInches / 12);
	const inches = lengthInInches % 12;
	return `${feet} ft ${inches} in`;
};

export const useTableData = ({ scrapData }: UseScrapTableDataProps) => {
	const rowData: IScrapRow[] = [];
	if (scrapData) {
		rowData.push({
			id: "scrap1",
			length: scrapData.Scrap1Length,
			pieces: scrapData.Scrap1Pieces,
			codeId: scrapData.Scrap1ReasonName,
		});
		rowData.push({
			id: "scrap2",
			length: scrapData.Scrap2Length,
			pieces: scrapData.Scrap2Pieces,
			codeId: scrapData.Scrap2ReasonName,
		});
	}

	const columns: ColGroupDef[] = [
		{
			headerName: "Scrap",
			children: [
				{
					field: "length",
					headerName: "Length",
					flex: 1,
					minWidth: 60,
					valueFormatter: (params) => formatLength(params.value),
					cellStyle: {
						textAlign: "center",
					},
				},
				{
					field: "pieces",
					headerName: "Pieces",
					flex: 1,
					minWidth: 60,
					cellStyle: {
						textAlign: "center",
					},
				},
				{
					field: "codeId",
					headerName: "Code",
					flex: 1,
					minWidth: 96,
					cellStyle: {
						textAlign: "right",
					},
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
		suppressHeaderMenuButton: true,
	};

	return { columns, defaultColDef, rowData };
};
